import React, { MouseEvent, ReactNode } from "react";

interface ButtonProps {
  isLoading?: boolean;
  disabled?: boolean;
  submit?: boolean;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  children?: ReactNode;
  [key: string]: any; // Allow any other props
}

export function Button({
  isLoading,
  disabled,
  submit,
  children,
  onClick,
  className = "",
  ...props
}: ButtonProps) {
  return (
    <button
      type={submit ? "submit" : "button"}
      disabled={disabled || isLoading}
      onClick={onClick}
      {...props}
      className={`bg-brand-color disabled:bg-[#6d9adf] disabled:bg-opacity-50 flex disabled:cursor-not-allowed flex-row justify-center items-center gap-2 text-white hover:bg-brand-hover h-12 font-semibold rounded-xl w-full px-3 py-4 ${className} ${
        isLoading ? "disabled:cursor-progress" : ""
      }`}
    >
      {isLoading && (
        <span className="rounded-full border-white block size-4 border border-t-blue-400 animate-spin" />
      )}
      {children}
    </button>
  );
}

export function SecondaryButton({
  isLoading,
  disabled,
  submit,
  children,
  onClick,
  className = "",
  ...props
}: ButtonProps) {
  return (
    <button
      type={submit ? "submit" : "button"}
      onClick={onClick}
      {...props}
      disabled={disabled || isLoading}
      className={`disabled:bg-[#D9DFE6] border border-[#D9DFE6] disabled:bg-opacity-50 flex disabled:cursor-not-allowed flex-row justify-center items-center gap-2 text-[#333333] hover:bg-[#D9DFE6] h-12 font-medium rounded-xl w-full px-3 py-4 ${className}`}
    >
      {isLoading && (
        <span className="rounded-full border-white block size-4 border border-t-blue-400 animate-spin" />
      )}
      {children}
    </button>
  );
}
